import { Component } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import { Subject } from 'rxjs';

import { PerimetreUtilisateurDialogComponent, PerimetreUtilisateurDialogData } from './perimetre-utilisateur-dialog.component';

@Component({
	selector: 'perimetre-utilisateur-button',
	templateUrl: 'perimetre-utilisateur-button.html',
})
export class PerimetreUtilisateurButtonComponent {
	openDialogRequests$ = new Subject<void>();	
	
	constructor(
		dialog: MatDialog,
	) {
		this.openDialogRequests$.subscribe(
			(_) => {
				let dialogRef = dialog.open(PerimetreUtilisateurDialogComponent, {
					width: '600px',
					panelClass: 'aurora-dialog-container',
					data: {
					} as PerimetreUtilisateurDialogData,
					disableClose: false,
				});

				dialogRef.afterClosed().subscribe(
					() => {
						// Pas de reaction particuliere sur la fermeture du dialogue
					}
				);
			}
		)
	}
}